import { BiDashboardPermission } from '@euler/model/bi/dashboard';

const kEditors = new Set([
  BiDashboardPermission.Edit,
  BiDashboardPermission.Manage,
]);

/** Whether a permission may change the dashboard's cards. */
export function biCanEdit(permission: BiDashboardPermission): boolean {
  return kEditors.has(permission);
}
